export const DTOTiposDocumentos: ITiposDocumentos[] = [
   {cod:"CC", desc:"Cedula de Ciudadania"}, 
   {cod:"CE", desc:"Cedula de Extranjeria"}, 
   {cod:"NIT", desc:"N.I.T."}, 
   {cod:"PA", desc:"Pasaporte"}, 
   {cod:"TI", desc:"Tarjeta de Identidad"}, 
   {cod:"CD", desc:"Carnet diplomatico"}, 
   {cod:"CA", desc:"Cedula antigua"}
]

export interface ITiposDocumentos {
    cod: string,
    desc :string
}


export interface ILinksAyuda {
    urlAuti: string,
    urlRecuperarClave: string,
    urlCalendario: string,
    urlNoticias: string,
    urlPreguntasFrec: string,
    urlEventosTrib: string,
    urlCambiaCorreo: string,
    urlInstructivos: string,
    urlRecaudoAno: string,
    urlAyudaDescuento: string,
    msgEmergencia: string
}

export const DTOLinksAyuda = {
    urlAuti: "",
    urlRecuperarClave: "",
    urlCalendario: "",
    urlNoticias: "",
    urlPreguntasFrec: "",
    urlEventosTrib: "",
    urlCambiaCorreo: "",
    urlInstructivos: "",
    urlRecaudoAno: "",
    urlAyudaDescuento: "",
    msgEmergencia: ""
}